/*globals $ */

// import Carousel from './Carousel';
import HowtoSlider from './HowtoSlider';

class ContentPanel {
  constructor(switcher, $el) {
    this.switcher = switcher;
    this.$el = $el;
    this.hasSlider = false;
    this.hasMovie = false;
    this.isShow = false;

    if(this.$el.css('display') == 'block') {
      this.isShow = true;
    }

    /*
    if(this.$el.hasClass('ContentSwitcherPanel--has-slider')) {
      this.hasSlider = true;

      let _options = {
        'pc': null,
        'tablet': null,
        'sp': {
          autoplay         : false,
          arrows           : false,
          slidesToShow: 1,
          slidesToScroll   : 1,
          dots: true,
          infinite: false,
          pauseOnHover: false
        }
      };

      this.carousel = new Carousel(this.$el.find('.slick-slider--delay'), _options);
    }
    */

    if(this.$el.hasClass('ContentSwitcherPanel--has-slider')) {
      this.hasSlider = true;
      this.slider = new HowtoSlider($('.js-howto-slider'));
    }

    if(this.$el.hasClass('ContentSwitcherPanel--has-movie')) {
      this.hasMovie = true;
    }
  }

  fadein(viewMode) {
    this.isShow = true;
    this.$el.css({
      'display': 'block',
      'opacity': 1,
    });

    if(this.hasSlider) {
      /*
      if(this.carousel.$target.hasClass('slick-initialized')) {
        this.carousel.$target.slick('unslick');
        this.carousel.$target.addClass('slick-slider--delay');
      }
      this.carousel.init(viewMode);
      */
      this.slider.show(viewMode);
    }

    if(this.hasMovie) {
      if(!$('.EmbedWrap__inner iframe').length) {
        let movieId = $('.EmbedWrap').attr('data-id');
        $('.EmbedWrap__inner').append(`<iframe width="560" height="315" src="https://www.youtube.com/embed/${movieId}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`);
      }
    }

    setTimeout(() => {
      this.switcher.$heightElement
        .stop(false)
        .animate({'height':this.getHeight()}, 400, 'easeInOutSine');

      this.$el.animate({'opacity':1}, 400, 'easeInOutSine', () => {
        this.switcher.$heightElement.css('height', 'auto');
      });

    }, 60);
  }

  fadeout() {
    this.isShow = false;
    this.$el.css({
      'display': 'none',
      'opacity': 0
    });

    if(this.hasSlider) {
      this.slider.hide();
    }

    /*
    if(this.carousel != undefined && this.carousel.$target.hasClass('slick-initialized')) {
      this.carousel.$target.slick('unslick');
      this.carousel.$target.addClass('slick-slider--delay');
    }
    */
  }

  getHeight() {
    return this.$el.height();
  }

  onWindowResize(viewMode) {
    if(this.isShow && this.hasSlider) {
      this.slider.show(viewMode);
    }
  }
}

class ContentSwitcher {
  constructor(mainApp) {
    this.mainApp          = mainApp;
    this.$container       = $('.ContentSwitcher');
    this.$tab             = this.$container.find('.ContentSwitcherTab');
    this.$heightElement   = this.$container.find('.ContentSwitcherHeight');
    this.$btns            = [];
    this.$panels          = [];
    this.currentPanel     = 0;
    this.tabHeight        = 80;

    this.$container.find('.ContentSwitcherTab__btn').each((i, e) => {
      this.$btns.push($(e));
    });

    this.$container.find('.ContentSwitcherPanel').each((i, e) => {
      this.$panels.push(new ContentPanel(this, $(e)));
    });

    this.$container.find('.ContentSwitcherTab__btn').on('click', (e) => {
      this.select($(e.currentTarget).attr('data-index'));
    });

    $(window).on('resize', () => {
      this.onWindowResize();
    });
    this.onWindowResize();
  }

  onWindowResize() {
    for(let i = 0; i < this.$btns.length; i++) {
      this.$panels[i].onWindowResize(this.mainApp.viewMode);
    }
    if(this.mainApp.viewMode == 'sp') {
      this.tabHeight = 58;
    } else {
      this.tabHeight = 80;
    }

    this.height = this.$container.outerHeight();
  }

  onWindowScroll(scrollTop) {
    if(scrollTop > this.$container.offset()['top'] + this.$container.outerHeight() - this.tabHeight - 10) {
      this.mainApp.canMoveHeader = true;
      this.mainApp.canMoveSpHeader = true;
      this.$tab.removeClass('ContentSwitcherTab--fixed');
      this.$tab.addClass('ContentSwitcherTab--bottom');
    } else if(scrollTop >= this.$container.offset()['top']) {
      this.mainApp.canMoveHeader = false;
      this.mainApp.canMoveSpHeader = false;
      this.$tab.removeClass('ContentSwitcherTab--bottom');
      this.$tab.addClass('ContentSwitcherTab--fixed');
    } else {
      this.mainApp.canMoveHeader = true;
      this.mainApp.canMoveSpHeader = true;
      this.$tab.removeClass('ContentSwitcherTab--fixed ContentSwitcherTab--bottom');
    }
  }

  select(target) {
    this.mainApp.canMoveHeader = false;
    this.mainApp.canMoveSpHeader = false;
    this.$heightElement.css('height', this.$panels[this.currentPanel].getHeight());
    $('html, body').animate({'scrollTop': this.$container.offset()['top']}, 800, 'easeInOutExpo', () => {
      setTimeout(() => {
        this.mainApp.canMoveHeader = true;
        this.mainApp.canMoveSpHeader = true;
      }, 50);
    });

    for(let i = 0; i < this.$btns.length; i++) {
      if(i == target) {
        this.$btns[i].addClass('ContentSwitcherTab__btn--current');
        this.$panels[i].fadein(this.mainApp.viewMode);
      } else {
        this.$btns[i].removeClass('ContentSwitcherTab__btn--current');
        this.$panels[i].fadeout();
      }

    }
    this.currentPanel = target;
  }
}

export default ContentSwitcher;
